import React, { FC } from 'react';
import AvailableJobsForm from '../../components/availableJobs';
import { Container } from '../../components/base/grid';
import Breadcrumbs from '../../components/breadcrumbs';
import SplitHero from '../../components/hero/splitHero';
import pageWrapper from '../../hoc/pageWrapper';

interface Props {
	page: any;
}

const AvailableJobs: FC<Props> = ({ page }) => {
	return (
		<Container>
			<Breadcrumbs pageId={page.Id} />
			{page.Values.HeroImage && page.Values.HeroContent.length > 0 && (
				<SplitHero
					pageId={page.Id}
					title={page.Values.HeroTitle || page.Name}
					content={page.Values.HeroContent}
					button={page.Values.HeroButton}
					image={page.Values.HeroImage}
				/>
			)}
			<AvailableJobsForm />
		</Container>
	);
};

export default pageWrapper(AvailableJobs);
